
import { ArrowDownOutlined, ArrowUpOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react'
import styled  from 'styled-components'

const DataCardView = styled.div`
  padding: 15px;
  background-color: #fff;
  margin: 7px 15px 7px 0px;
  .title {
    font-size: 14px;
    color: rgba(0, 0, 0, .45);
  }

  .number {
    font-size: 30px;
    font-weight: bold;
    color: rgba(0, 0, 0, .85);
    margin: 16px 0;
    line-height: 0.9;
  }
  .relativeRatio {
    margin: 0 -16px;
    padding: 14px 16px 0 16px;
    border-top: 1px solid #e8e8e8;
    font-size: 14px;
    color: rgba(0, 0, 0, .45);
  }
`


interface DataCardProps {
  title: string;
  number: string|number;
  relativeRatio: string;  // -60
  hideRelativeRatio?: boolean
  useRelativeV2?: boolean
  showRelativeArrow?: boolean
  ratioLabel?: string
  upColor?: string
  downColor?: string
  titleTip?: React.ReactNode
}


export const DataCard = (props:DataCardProps)=>{
  let { title,number,relativeRatio } = props
  let relativeNumber = Number(relativeRatio)
  let isDown = relativeNumber < 0
  const hasV2Config =
    props.showRelativeArrow !== undefined ||
    props.ratioLabel !== undefined ||
    props.upColor !== undefined ||
    props.downColor !== undefined ||
    props.titleTip !== undefined
  const isV2 = props.useRelativeV2 !== undefined ? props.useRelativeV2 : hasV2Config
  const getRelativeRatio = ()=>{
    if(props.hideRelativeRatio){
      return 
    }
    return <div className='relativeRatio' >
      环比:
      <span style={{ margin: '0 8px' }}>{relativeRatio || '--'}%</span>
      {relativeNumber != 0 ? (isDown ? <ArrowDownOutlined style={{ color: 'green' }} /> : <ArrowUpOutlined style={{ color: 'red' }} />) : null}
    </div>
  }

  const getRelativeRatioV2 = ()=>{
    if(props.hideRelativeRatio || props.ratioLabel == ''){
      return <div className='relativeRatio' style={{ minHeight:'35px'}}  ></div>
    }
    const shouldShowArrow = props.showRelativeArrow === false ? false : true
    const labelText = props.ratioLabel ?? '环比'
    const upArrowColor = props.upColor ?? 'red'
    const downArrowColor = props.downColor ?? 'green'
    return <div className='relativeRatio' >
        {`${labelText}:`}
      <span style={{ margin: '0 8px' }}>{relativeRatio || '--'}%</span>
      {!shouldShowArrow || relativeNumber == 0 ? null : (isDown ? <ArrowDownOutlined style={{ color: downArrowColor }} /> : <ArrowUpOutlined style={{ color: upArrowColor }} />)}
    </div>
  }
  
  const renderRelativeRatio = ()=>{
    return isV2 ? getRelativeRatioV2() : getRelativeRatio()
  }

  return <DataCardView  className='data-card'>
    <div className='title'>
      {title}
      { props.titleTip ? (
        <Tooltip title={props.titleTip}>
          <QuestionCircleOutlined style={{ marginLeft: 6 }} />
        </Tooltip>
      ) : null}
    </div>
    <div className='number'>{number||'--'}</div>
    { renderRelativeRatio() }
  </DataCardView>
}
